import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBuilding, FaCheckCircle, FaEnvelope, FaBell, FaPlus } from 'react-icons/fa';
import { adminApi, formatPrice } from '../../services/api';
import AdminLayout from './AdminLayout';
import './Admin.css';

const StatCard = ({ icon, label, value, color, link }) => (
  <Link to={link || '#'} className={`stat-card stat-card--${color}`}>
    <div className="stat-card__icon">{icon}</div>
    <div className="stat-card__data">
      <div className="stat-card__value">{value ?? '—'}</div>
      <div className="stat-card__label">{label}</div>
    </div>
  </Link>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentProps, setRecentProps] = useState([]);
  const [recentMsgs, setRecentMsgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [statsRes, propsRes, msgsRes] = await Promise.all([
          adminApi.getStats(),
          adminApi.getAllProperties(),
          adminApi.getAllMessages(),
        ]);
        setStats(statsRes.data?.data);
        setRecentProps((propsRes.data?.data || []).slice(0, 5));
        setRecentMsgs((msgsRes.data?.data || []).slice(0, 5));
      } catch (_) {
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, []);

  return (
    <AdminLayout title="Dashboard">
      {loading ? (
        <div className="admin-loading"><div className="spinner" /></div>
      ) : (
        <>
          <div className="stat-grid">
            <StatCard
              icon={<FaBuilding />}
              label="Total Propiedades"
              value={stats?.totalProperties}
              color="blue"
              link="/admin12/propiedades"
            />
            <StatCard
              icon={<FaCheckCircle />}
              label="Disponibles"
              value={stats?.availableProperties}
              color="green"
              link="/admin12/propiedades"
            />
            <StatCard
              icon={<FaEnvelope />}
              label="Mensajes"
              value={stats?.totalMessages}
              color="purple"
              link="/admin12/mensajes"
            />
            <StatCard
              icon={<FaBell />}
              label="Sin leer"
              value={stats?.unreadMessages}
              color="orange"
              link="/admin12/mensajes"
            />
          </div>

          <div className="dashboard-grid">
            {/* Propiedades recientes */}
            <div className="admin-card">
              <div className="admin-card__header">
                <h3>Propiedades Recientes</h3>
                <Link to="/admin12/propiedades/nueva" className="btn btn--gold">
                  <FaPlus /> Nueva
                </Link>
              </div>
              {recentProps.length === 0 ? (
                <p className="admin-empty">No hay propiedades aún.</p>
              ) : (
                <div className="admin-table-wrapper">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Propiedad</th>
                        <th>Precio</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentProps.map(p => (
                        <tr key={p.id}>
                          <td>
                            <Link to={`/admin12/propiedades/editar/${p.id}`}>
                              {p.title}
                            </Link>
                          </td>
                          <td>{formatPrice(p.price, p.currency)}</td>
                          <td>
                            <span className={`status-badge status-badge--${p.status?.toLowerCase()}`}>
                              {p.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <Link to="/admin12/propiedades" className="admin-card__more">
                Ver todas las propiedades →
              </Link>
            </div>

            {/* Mensajes recientes */}
            <div className="admin-card">
              <div className="admin-card__header">
                <h3>Mensajes Recientes</h3>
              </div>
              {recentMsgs.length === 0 ? (
                <p className="admin-empty">No hay mensajes aún.</p>
              ) : (
                <div className="recent-messages">
                  {recentMsgs.map(m => (
                    <div
                      key={m.id}
                      className={`recent-msg ${!m.read ? 'recent-msg--unread' : ''}`}
                    >
                      <div className="recent-msg__header">
                        <strong>{m.name}</strong>
                        {!m.read && <span className="unread-dot" />}
                      </div>
                      <div className="recent-msg__subject">{m.subject}</div>
                      <div className="recent-msg__email">{m.email}</div>
                    </div>
                  ))}
                </div>
              )}
              <Link to="/admin12/mensajes" className="admin-card__more">
                Ver todos los mensajes →
              </Link>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
};

export default AdminDashboard;
